// extracted by mini-css-extract-plugin
export var resizer = "_ex-0";